import { ImageKeys } from "../img/Images";
import ChecklistItem from "./ChecklistItem";

export default interface ChecklistItemImage extends ChecklistItem {
	image: ImageKeys;
}

export const isChecklistItemImage = (object: any): object is ChecklistItemImage => {
	return "image" in object;
};